import api from './api';

const storeService = {
  // 获取门店列表
  getStores: async (params = {}) => {
    try {
      const response = await api.get('/stores', { params });
      return response.data;
    } catch (error) {
      console.error('获取门店列表失败:', error);
      throw error;
    }
  },

  // 获取门店详情
  getStore: async (id) => {
    try {
      const response = await api.get(`/stores/${id}`);
      return response.data;
    } catch (error) {
      console.error('获取门店详情失败:', error);
      throw error;
    }
  },

  // 创建门店
  createStore: async (storeData) => {
    try {
      const response = await api.post('/stores', storeData);
      return response.data;
    } catch (error) {
      console.error('创建门店失败:', error);
      throw error;
    }
  },

  // 更新门店
  updateStore: async (id, storeData) => {
    try {
      const response = await api.put(`/stores/${id}`, storeData);
      return response.data;
    } catch (error) {
      console.error('更新门店失败:', error);
      throw error;
    }
  },

  // 删除门店
  deleteStore: async (id) => {
    try {
      await api.delete(`/stores/${id}`);
    } catch (error) {
      console.error('删除门店失败:', error);
      throw error;
    }
  },

  // 地址解析
  geocodeAddress: async (address) => {
    try {
      const response = await api.post('/stores/geocode', address, {
        headers: {
          'Content-Type': 'text/plain'
        }
      });
      return response.data;
    } catch (error) {
      console.error('地址解析失败:', error);
      throw error;
    }
  },

  // 根据坐标查找最近门店
  findNearestStore: async (longitude, latitude) => {
    try {
      const response = await api.get('/stores/nearest', {
        params: { longitude, latitude }
      });
      return response.data;
    } catch (error) {
      console.error('查找最近门店失败:', error);
      throw error;
    }
  },

  // 根据坐标查找服务范围内的门店
  findStoresInRange: async (longitude, latitude) => {
    try {
      const response = await api.get('/stores/in-range', {
        params: { longitude, latitude }
      });
      return response.data;
    } catch (error) {
      console.error('查找范围内门店失败:', error);
      throw error;
    }
  },

  // 下载Excel模板
  downloadTemplate: async () => {
    try {
      const response = await api.get('/stores/template', {
        responseType: 'blob'
      });
      
      // 创建下载链接
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'store_template.xlsx');
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('下载Excel模板失败:', error);
      throw error;
    }
  },

  // 批量导入门店
  importStores: async (file) => {
    try {
      const formData = new FormData();
      formData.append('file', file);
      
      const response = await api.post('/stores/import', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
      return response.data;
    } catch (error) {
      console.error('批量导入门店失败:', error);
      throw error;
    }
  },

  // 地址搜索建议
  searchAddress: async (keywords) => {
    try {
      const response = await api.get('/stores/address-search', {
        params: { keywords }
      });
      return response;
    } catch (error) {
      console.error('地址搜索失败:', error);
      throw error;
    }
  }
};

export default storeService;